<template>
  <div class="al-shell">
    <!-- Left: brand panel -->
    <div class="al-brand">
      <div class="al-brand-inner">
        <div class="al-brand-logo">
          <svg width="52" height="52" viewBox="0 0 48 48" fill="none">
            <rect width="48" height="48" rx="12" fill="rgba(255,255,255,0.12)"/>
            <path d="M24 10L36 18V30L24 38L12 30V18L24 10Z" fill="white" fill-opacity="0.18" stroke="white" stroke-width="2"/>
            <circle cx="24" cy="24" r="6" fill="white"/>
          </svg>
          <span class="al-brand-appname">Obra Tycoon</span>
        </div>

        <div class="al-brand-body">
          <h2 class="al-brand-headline">Painel Administrativo</h2>
          <p class="al-brand-tagline">Gestão centralizada de obras, usuários e recursos em um só lugar.</p>
          <ul class="al-brand-features">
            <li>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              Visão geral de todas as obras
            </li>
            <li>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              Analytics de uso e armazenamento
            </li>
            <li>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              Backup e importação de dados
            </li>
          </ul>
        </div>

        <p class="al-brand-version">v0.6.0</p>
      </div>
    </div>

    <!-- Right: form panel -->
    <div class="al-form-panel">
      <div class="al-form-wrap">
        <div class="al-form-header">
          <h1 class="al-form-title">Entrar</h1>
          <p class="al-form-sub">Use suas credenciais de administrador</p>
        </div>

        <form @submit.prevent="handleLogin" class="al-form" novalidate>
          <div class="al-field">
            <label class="al-label" for="admin-username">Usuário</label>
            <div class="al-input-wrap">
              <svg class="al-input-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              <input
                id="admin-username"
                v-model="username"
                type="text"
                class="al-input"
                placeholder="admin"
                autocomplete="username"
              />
            </div>
          </div>

          <div class="al-field">
            <label class="al-label" for="admin-password">Senha</label>
            <div class="al-input-wrap">
              <svg class="al-input-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
              <input
                id="admin-password"
                v-model="password"
                :type="showPassword ? 'text' : 'password'"
                class="al-input"
                placeholder="••••••"
                autocomplete="current-password"
              />
              <button type="button" class="al-eye-btn" @click="showPassword = !showPassword" tabindex="-1" aria-label="Mostrar senha">
                <svg v-if="!showPassword" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
              </button>
            </div>
          </div>

          <!-- 2FA: passo do código (aparece quando o servidor pede) -->
          <div v-if="twofaRequired" class="al-field">
            <label class="al-label" for="admin-2fa">Código de verificação (2FA)</label>
            <div class="al-input-wrap">
              <svg class="al-input-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
              <input
                id="admin-2fa"
                v-model="twofaToken"
                type="text"
                inputmode="numeric"
                class="al-input"
                placeholder="000000 ou código de recuperação"
                autocomplete="one-time-code"
                ref="twofaInput"
              />
            </div>
            <p class="al-2fa-hint">Abra seu app autenticador (celular ou PC) e digite o código de 6 dígitos. Sem o app? Use um código de recuperação.</p>
          </div>

          <div v-if="error" class="al-error" role="alert">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            {{ error }}
          </div>

          <button type="submit" class="al-btn" :disabled="loading">
            <span v-if="loading" class="al-spinner"></span>
            {{ loading ? 'Autenticando...' : (twofaRequired ? 'Verificar e entrar' : 'Entrar') }}
          </button>
        </form>

        <p class="al-security-note">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
          Acesso restrito · Sessão criptografada
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, nextTick, ref } from 'vue'
import { useRouter } from 'vue-router'
import { masterSessionStore } from '@/store/masterSession'

const apiBase = process.env.VUE_APP_API_BASE || 'http://localhost:3001'

export default defineComponent({
  name: 'AdminLoginView',
  setup() {
    const router = useRouter()
    const username = ref('')
    const password = ref('')
    const twofaToken = ref('')
    const twofaRequired = ref(false)
    const twofaInput = ref<HTMLInputElement | null>(null)
    const error = ref('')
    const loading = ref(false)
    const showPassword = ref(false)

    // Login usa fetch direto (não masterFetch) para poder ler o 401 com
    // twofaRequired sem disparar o auto-logout do masterFetch.
    const handleLogin = async () => {
      error.value = ''
      if (!username.value.trim() || !password.value.trim()) {
        error.value = 'Preencha usuário e senha.'
        return
      }
      if (twofaRequired.value && !twofaToken.value.trim()) {
        error.value = 'Informe o código de verificação.'
        return
      }
      loading.value = true
      try {
        const body: Record<string, string> = {
          username: username.value.trim(),
          password: password.value.trim()
        }
        if (twofaRequired.value) body.twofaToken = twofaToken.value.trim()
        const response = await fetch(`${apiBase}/master-login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        })
        const data = await response.json().catch(() => ({}))
        if (!response.ok) {
          if (data.twofaRequired) {
            twofaRequired.value = true
            error.value = twofaToken.value.trim() ? (data.error || 'Código inválido.') : ''
            nextTick(() => twofaInput.value?.focus())
            return
          }
          error.value = data.error || 'Credenciais inválidas.'
          return
        }
        masterSessionStore.login({ username: data.username, name: data.name }, data.token)
        router.push('/administrador/dashboard')
      } catch (err: unknown) {
        error.value = err instanceof Error ? err.message : 'Erro de conexão.'
      } finally {
        loading.value = false
      }
    }

    return { username, password, twofaToken, twofaRequired, twofaInput, error, loading, handleLogin, showPassword }
  }
})
</script>

<style scoped lang="scss">
* { box-sizing: border-box; }

.al-shell {
  display: flex;
  min-height: 100vh;
  font-family: 'Inter', 'Segoe UI', sans-serif;
}

/* ── Brand panel ── */
.al-brand {
  width: 440px;
  flex-shrink: 0;
  background: linear-gradient(160deg, #0f4c81 0%, #0a3460 100%);
  display: flex;
  align-items: stretch;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background:
      radial-gradient(circle at 20% 20%, rgba(255,255,255,0.06) 0%, transparent 60%),
      radial-gradient(circle at 80% 80%, rgba(255,255,255,0.04) 0%, transparent 60%);
  }
}

.al-brand-inner {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  padding: 48px 40px;
  width: 100%;
}

.al-brand-logo {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 64px;
}

.al-brand-appname {
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.al-brand-body {
  flex: 1;
}

.al-brand-headline {
  color: #fff;
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 12px;
  line-height: 1.2;
  letter-spacing: -0.02em;
}

.al-brand-tagline {
  color: rgba(255,255,255,0.65);
  font-size: 14px;
  line-height: 1.6;
  margin: 0 0 32px;
}

.al-brand-features {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;

  li {
    display: flex;
    align-items: center;
    gap: 10px;
    color: rgba(255,255,255,0.8);
    font-size: 13px;
    font-weight: 500;

    svg { flex-shrink: 0; opacity: 0.9; }
  }
}

.al-brand-version {
  color: rgba(255,255,255,0.3);
  font-size: 11px;
  margin: 0;
  margin-top: 32px;
}

/* ── Form panel ── */
.al-form-panel {
  flex: 1;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 32px;
}

.al-form-wrap {
  width: 100%;
  max-width: 360px;
}

.al-form-header {
  margin-bottom: 32px;
}

.al-form-title {
  font-size: 26px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 6px;
  letter-spacing: -0.02em;
}

.al-form-sub {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

.al-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.al-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.al-label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
}

.al-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.al-input-icon {
  position: absolute;
  left: 12px;
  color: #9ca3af;
  pointer-events: none;
  flex-shrink: 0;
}

.al-input {
  width: 100%;
  padding: 10px 12px 10px 38px;
  border: 1.5px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  color: #111827;
  background: #fff;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;

  &::placeholder { color: #9ca3af; }

  &:focus {
    border-color: #0f4c81;
    box-shadow: 0 0 0 3px rgba(15,76,129,0.12);
  }
}

.al-eye-btn {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  color: #9ca3af;
  display: flex;
  align-items: center;
  padding: 4px;
  border-radius: 4px;
  transition: color 0.15s;

  &:hover { color: #374151; }
}

.al-error {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #dc2626;
  font-size: 13px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 10px 12px;
}

.al-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #0f4c81;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px;
  font-size: 15px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  margin-top: 4px;
  transition: background 0.15s, transform 0.1s;

  &:hover:not(:disabled) {
    background: #0d3d6a;
  }

  &:active:not(:disabled) {
    transform: scale(0.99);
  }

  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
}

.al-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255,255,255,0.35);
  border-top-color: #fff;
  border-radius: 50%;
  animation: al-spin 0.7s linear infinite;
  flex-shrink: 0;
}

@keyframes al-spin {
  to { transform: rotate(360deg); }
}

.al-2fa-hint {
  font-size: 11px;
  color: #9ca3af;
  margin: 6px 2px 0;
  line-height: 1.5;
}
.al-security-note {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #9ca3af;
  font-size: 11px;
  margin: 20px 0 0;
  justify-content: center;

  svg { flex-shrink: 0; }
}

/* Responsive: stack on narrow screens */
@media (max-width: 720px) {
  .al-shell { flex-direction: column; }

  .al-brand {
    width: 100%;
    padding: 0;
  }

  .al-brand-inner {
    padding: 32px 24px;
  }

  .al-brand-logo { margin-bottom: 24px; }
  .al-brand-headline { font-size: 20px; }
  .al-brand-body { flex: unset; }
  .al-brand-features { display: none; }

  .al-form-panel {
    padding: 32px 24px;
  }
}
</style>
